import { apiClient } from './api-client'
import { API_ENDPOINTS } from '@/config/constants'
import { Client, CreateClientDto, UpdateClientDto } from '@/types'

export const clientsService = {
  getAll: async (): Promise<Client[]> => {
    return apiClient.get<Client[]>(API_ENDPOINTS.CLIENTS.BASE)
  },

  getAttached: async (): Promise<Client[]> => {
    return apiClient.get<Client[]>(API_ENDPOINTS.CLIENTS.ATTACHED)
  },

  getById: async (id: string): Promise<Client> => {
    return apiClient.get<Client>(API_ENDPOINTS.CLIENTS.BY_ID(id))
  },

  create: async (data: CreateClientDto): Promise<Client> => {
    return apiClient.post<Client>(API_ENDPOINTS.CLIENTS.BASE, data)
  },

  update: async (id: string, data: UpdateClientDto): Promise<Client> => {
    return apiClient.patch<Client>(API_ENDPOINTS.CLIENTS.BY_ID(id), data)
  },

  enable: async (id: string): Promise<Client> => {
    return apiClient.patch<Client>(API_ENDPOINTS.CLIENTS.ENABLE(id))
  },

  disable: async (id: string): Promise<Client> => {
    return apiClient.patch<Client>(API_ENDPOINTS.CLIENTS.DISABLE(id))
  },

  block: async (id: string): Promise<Client> => {
    return apiClient.patch<Client>(API_ENDPOINTS.CLIENTS.BLOCK(id))
  },

  unblock: async (id: string): Promise<Client> => {
    return apiClient.patch<Client>(API_ENDPOINTS.CLIENTS.UNBLOCK(id))
  },

  terminate: async (id: string): Promise<Client> => {
    return apiClient.patch<Client>(API_ENDPOINTS.CLIENTS.TERMINATE(id))
  },

  delete: async (id: string): Promise<void> => {
    return apiClient.delete<void>(API_ENDPOINTS.CLIENTS.BY_ID(id))
  },
}
